import React from "react";

import { HEADER_STRINGS, landingPageStrings } from "constants/constantStrings";

import "./index.scss";

const NotAuthorized = () => (
  <>
    <div className="unautorized-user">
      <div className="d-flex margin-auto">
        <span className="unautorized-user--icon" />
        <div className="unautorized-user__info">
          <span className="unautorized-user__info--logo">{landingPageStrings.waterSolutions}</span>
          <div className="unautorized-user__info--text">
            <label className="title">{landingPageStrings.welcomeTo}</label>
            <div>
              <span className="desalitec-logo--heading">
                {HEADER_STRINGS.desaliTec}
                <sup className="desalitec-logo--trade-mark">&trade;</sup>
              </span>
              <span className="desalitec-logo--secondary-heading desalitec-logo--name-spacing">{HEADER_STRINGS.soarSmart}</span>
            </div>
            <div className="message">
              {landingPageStrings.noPermission} <br />
              {landingPageStrings.contactAdmin}
              <label>{landingPageStrings.adminEmail}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
);

export default NotAuthorized;
